import { Chip, Stack, TextField, Typography } from '@mui/material'
import type { FC } from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import { useFormikProps } from './EditMultipleChoiceSet.hooks'

const NameRow: FC = () => {
  const {
    formikProps: { setFieldValue, values, errors, touched },
  } = useFormikProps()

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          component="label"
          htmlFor="multiple-choice-set-name"
          variant="subtitle1"
        >
          セット選択肢名
        </Typography>
        <Chip label="必須" variant="required" size="small" />
      </Stack>
      <TextField
        value={values.name}
        onChange={e => setFieldValue('name', e.target.value)}
        slotProps={{
          htmlInput: { id: 'multiple-choice-set-name', maxLength: 255 },
        }}
        size="small"
      />
      <FormikErrorMessage name="name" errors={errors} touched={touched} />
    </Stack>
  )
}

export default NameRow
